import { useState } from 'react';

let cached: boolean | null = null;

export function isWebGLAvailable(): boolean {
	if (typeof document === 'undefined') return false;
	if (cached !== null) return cached;
	try {
		const canvas = document.createElement('canvas');
		const gl =
			canvas.getContext('webgl2') ?? canvas.getContext('webgl') ?? null;
		cached = gl !== null;
		gl?.getExtension('WEBGL_lose_context')?.loseContext();
	} catch {
		cached = false;
	}
	return cached;
}

export function useWebGLAvailable(): boolean {
	const [available] = useState(isWebGLAvailable);
	return available;
}
